webpackJsonp([177],{

/***/ 1319:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UsersDetailWorkInfoLog_vue__ = __webpack_require__(3089);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6be9b1d4_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UsersDetailWorkInfoLog_vue__ = __webpack_require__(5795);
function injectStyle (ssrContext) {
  __webpack_require__(5793)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6be9b1d4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UsersDetailWorkInfoLog_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6be9b1d4_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UsersDetailWorkInfoLog_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 1348:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export removeDefaultParams */
/* harmony export (immutable) */ __webpack_exports__["c"] = trimParams;
/* harmony export (immutable) */ __webpack_exports__["b"] = removeEmptyParams;
/* unused harmony export setParams */
/* unused harmony export setDefaultParams */
/* unused harmony export conveDataType */
/* unused harmony export conveSomeDataType */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);


/*
 * 表格页面的通用方法
 * @Author: anker.wang
 * @Date: 2018-01-08 11:25:59
 * @Last Modified by: anker.wang
 * @Last Modified time: 2018-06-27 12:12:26
 * @Description 路由参数自动同步到搜索参数;在路由更新时获得表格数据;使用分页和搜索事件自动变更路由
 */



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      // 搜索表单字段
      search: {},
      // 搜索字段申明
      searchFieldType: {},
      // 表格数据
      table: [],
      // 分页参数
      pagination: {
        current_page: 1,
        per_page: 50,
        total: 0
      },
      refSearchForm: 'searchForm',
      lastSearchParams: {},
      isLoadTableInBeforeRouteEnter: true,
      isLoadTableInBeforeRouteUpdate: true
    };
  },

  // 路由进入时
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    // 在导航转入新的路由前
    next(function (vm) {
      if (vm.isLoadTableInBeforeRouteEnter) {
        // 处理路由参数
        var queryParams = vm.getRouterQueryParams(to.query, to.params);
        // 设置搜索参数。 当仅 params 更新时, 需要全部重置 search 数据
        vm.setSearchParams(_.merge(vm.$options.data.call(vm).search, queryParams));
        // 加载表格数据
        vm.loadTableData(queryParams);
      }
    });
  },

  // 路由更新时
  beforeRouteUpdate: function beforeRouteUpdate(to, from, next) {
    if (this.isLoadTableInBeforeRouteUpdate) {
      // 处理路由参数
      var queryParams = this.getRouterQueryParams(to.query, to.params);
      // 加载表格数据
      this.loadTableData(queryParams);
    }
    // 继续加载路由
    next();
  },

  methods: {
    /**
     * 获得表格数据
     * @param {*} params
     */
    getTableData: function getTableData(params) {},

    /**
     * 设置表格数据
     * @param {*} params
     */
    setTableData: function setTableData(_ref) {
      var data = _ref.data;

      this.$set(this, 'table', data.data);
      this.setPagination(data);
    },

    /**
     * 获得搜索参数
     */
    getSearchParams: function getSearchParams() {
      return this.search;
    },

    /**
     * 设置搜索参数
     */
    setSearchParams: function setSearchParams(params) {
      setParams(this.search, params);
    },

    /**
     * 获得搜索参数的类型声明
     * @description 从路由上同步参数时会造成获得全部都是字符串
     */
    getSearchFieldType: function getSearchFieldType() {
      return this.searchFieldType;
    },

    /**
     * 获取分页数据
     */
    getPagination: function getPagination() {
      return {
        current_page: this.pagination.current_page,
        per_page: this.pagination.per_page
      };
    },

    /**
     * 设置分页数据
     * @pagination {current_page, per_page, total}
     */
    setPagination: function setPagination(pagination) {
      // 转换数据类型
      pagination = conveSomeDataType(pagination, this.pagination);
      // 设置参数
      setParams(this.pagination, pagination);
    },

    /**
     * 处理分页大小时的变化
     * @param {*} val
     */
    handleSizePageChange: function handleSizePageChange(val) {
      this.setPagination({ per_page: val });
      this.setRouterQueryParams(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, this.getRouterQueryParams(), this.getPagination()));
    },

    /**
     * 处理页码变化
     * @param {*} val
     */
    handleCurrentPageChange: function handleCurrentPageChange(val) {
      this.setPagination({ current_page: val });
      this.setRouterQueryParams(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, this.getRouterQueryParams(), this.getPagination()));
    },

    /**
     * 获得路由参数
     * 必须 search 中存在的字段，通过申明的类型转换
     * @param {*} query
     * @param {*} params
     */
    getRouterQueryParams: function getRouterQueryParams() {
      var query = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.$route.query;
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.$route.params;

      // 删除标识路由更新的空名字段
      if (query.hasOwnProperty('')) {
        delete query[''];
      }
      if (params.hasOwnProperty('')) {
        delete params[''];
      }
      // 获得参数默认值

      var _$options$data$call = this.$options.data.call(this),
          pagination = _$options$data$call.pagination,
          search = _$options$data$call.search;

      return conveSomeDataType(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, query, params), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, search, pagination), this.getSearchFieldType());
    },

    /**
     * 设置路由参数
     * @description 设置路由参数
     */
    setRouterQueryParams: function setRouterQueryParams() {
      var query = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      var _$options$data$call2 = this.$options.data.call(this),
          pagination = _$options$data$call2.pagination,
          search = _$options$data$call2.search;

      this.$router.replace({
        query: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, removeEmptyParams(trimParams(removeDefaultParams(query, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, search, pagination)))), {
          // 用于相同的搜索参数时也触发路由更新
          '': __WEBPACK_IMPORTED_MODULE_2_moment___default()().format('HHmmssSS')
        })
      });
    },

    /**
     * 加载表格数据
     * @param {*} params
     */
    loadTableData: function loadTableData(params) {
      // 移除空的参数
      params = removeEmptyParams(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, this.getSearchParams(), params));
      // 设置默认分页大小值

      var _$options$data$call3 = this.$options.data.call(this),
          pagination = _$options$data$call3.pagination;

      params = setDefaultParams(params, {
        current_page: pagination.current_page,
        per_page: pagination.per_page
      });
      // 保存本次请求参数
      this.lastSearchParams = params;
      // 获得表格数据
      this.getTableData(params).then(this.setTableData);
    },

    /**
     * 刷新当前页的表格数据
     */
    onRefresh: function onRefresh() {
      // 根据上次请求数据再次获取
      return this.getTableData(this.lastSearchParams).then(this.setTableData);
    },

    /**
     * 搜索列表方法
     * @param {*} params
     */
    onSearch: function onSearch(params) {
      var _this = this;

      var search = function search() {
        _this.setPagination({ current_page: 1 });
        _this.setRouterQueryParams(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, _this.getPagination(), _this.getSearchParams(), params));
      };
      // 验证填写参数
      var searchForm = this.$refs[this.refSearchForm];
      if (searchForm) {
        searchForm.validate(function (valid) {
          if (valid) {
            search();
          } else {
            _this.$message.error('搜索内容填写不正确！');
          }
        });
      } else {
        search();
      }
    },

    /**
     * 重置表单方法
     */
    resetSearch: function resetSearch() {
      this.$refs[this.refSearchForm].resetFields();
    }
  }

  /**
   * 移除参数中的默认参数
   * @param params
   * @param defaultParams
   * @returns {*}
   */
});function removeDefaultParams(params, defaultParams) {
  for (var key in defaultParams) {
    if (defaultParams.hasOwnProperty(key) && params.hasOwnProperty(key)) {
      if (_.isEqual(defaultParams[key], params[key])) {
        delete params[key];
      }
    }
  }
  return params;
}

/**
 * 移除参数中字符串的前后空格
 * @param params
 * @param defaultParams
 * @returns {*}
 */
function trimParams(params) {
  for (var key in params) {
    if (params.hasOwnProperty(key) && typeof params[key] === 'string') {
      params[key] = params[key].trim();
    }
  }
  return params;
}

/**
 * 删除空的参数
 * @param params
 * @returns {*}
 */
function removeEmptyParams(params) {
  for (var key in params) {
    if (params.hasOwnProperty(key)) {
      // 为数组时必须长度大于0
      if (params[key] instanceof Array && params[key].length === 0) {
        delete params[key];
      }
      // 空字符串或者null时删除字段
      if (params[key] === '' || params[key] === null) {
        delete params[key];
      }
    }
  }
  return params;
}

/**
 * 设置数据
 * @param params
 * @param newParams
 * @returns {*}
 */
function setParams(params, newParams) {
  for (var key in params) {
    if (params.hasOwnProperty(key) && newParams.hasOwnProperty(key)) {
      if (params[key] && params[key].constructor === Object) {
        setParams(params[key], newParams[key]);
      } else {
        Vue.set(params, key, newParams[key]);
      }
    }
  }
  return params;
}

/**
 * 设置默认参数
 * @param params
 * @param defaultParams
 * @returns {*}
 */
function setDefaultParams(params, defaultParams) {
  for (var key in defaultParams) {
    if (defaultParams.hasOwnProperty(key) && !params.hasOwnProperty(key)) {
      params[key] = defaultParams[key];
    }
  }
  return params;
}

/**
 * 数据类型转换
 * @param value
 * @param type
 */
function conveDataType(value, type) {
  // 类型相同不用转换
  if (value.constructor !== type) {
    // 实际类型为对象时进入内部
    if (type.constructor === Object && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(type).length > 0) {
      for (var key in value) {
        if (value.hasOwnProperty(key)) {
          // 声明为对象时逐个转换
          value[key] = conveDataType(value[key], type[key]);
        }
      }
    } else {
      value = type(value);
    }
  }
  return value;
}

/**
 * 转换一些数据类型
 * @param params
 * @param defaultParams
 * @param types
 * @returns {*}
 * @description
 * types = {
 *   count: Number,
 *   object: {
 *     id: Number,
 *     date: Date
 *   },
 *   array: {
 *     0: Number,
 *     1: Boolean
 *   },
 * }
 */
function conveSomeDataType(params, defaultParams, types) {
  for (var key in params) {
    if (params.hasOwnProperty(key) && params[key] !== null && params[key] !== undefined && defaultParams.hasOwnProperty(key)) {
      // 存在数据声明
      if (types && types.hasOwnProperty(key)) {
        params[key] = conveDataType(params[key], types[key]);
      } else if (defaultParams[key] !== null && defaultParams[key] !== undefined) {
        // 不存在获取默认参数的数据原类型
        var paramType = defaultParams[key].constructor;
        // 只对非对象数组的参数进行转换
        if (paramType !== Object) {
          params[key] = conveDataType(params[key], paramType);
        }
      }
    }
  }
  return params;
}

/***/ }),

/***/ 1355:
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__(992))(78);

/***/ }),

/***/ 1360:
/***/ (function(module, exports, __webpack_require__) {

module.exports = (__webpack_require__(992))(77);

/***/ }),

/***/ 1517:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(232);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(233);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__views_users_users_api_js__ = __webpack_require__(258);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);





/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    /**
     * 判断是否为图片文件
     * @param {string} url - 文件URL
     * @returns {boolean}
     */
    isImageFile: function isImageFile(url) {
      if (!url) return false;

      // 最后通过文件扩展名判断
      try {
        var path = new URL(url).pathname;
        var ext = path.split('.').pop().toLowerCase();
        if (['jpg', 'jpeg', 'png', 'gif', 'webp', 'svg', 'bmp', 'tiff', 'tif'].includes(ext)) {
          console.log(url + ' match img ext');
          return true;
        }
      } catch (error) {
        // do nothing
        console.log(error);
      }
      return false;
    },

    /**
     * 判断是否为视频文件
     * @param {string} url - 文件URL
     * @returns {boolean}
     */
    isVideoFile: function isVideoFile(url) {
      if (!url) return false;

      // 通过 URL 中的存储桶关键字快速判断
      var videoBuckets = ['sjrawvideopub.', 'sjrawvideopubdev.', 'sjvideopub.', 'sjvideopubdev.', 'sjvideopubcnv.', 'sjvideopubcnvdev.'];
      if (videoBuckets.some(function (bucket) {
        return url.includes(bucket);
      })) {
        console.log(url + ' match video bucket name');
        return true;
      }
      // 最后通过文件扩展名判断
      try {
        var path = new URL(url).pathname;
        var ext = path.split('.').pop().toLowerCase();
        if (['mp4', 'webm', 'ogg', 'mov', 'avi', 'wmv', 'flv', 'mkv', 'mpeg', 'mpg', 'm3u8', 'mpd'].includes(ext)) {
          console.log(url + ' match video ext');
          return true;
        }
      } catch (error) {
        // do nothing
      }
      return false;
    },
    onChangeUserWorkInfoEvidence: function onChangeUserWorkInfoEvidence(file) {
      var fileType = file.raw.type;
      var fileSizeMB = file.raw.size / 1024 / 1024;
      var isImage = fileType === 'image/jpeg' || fileType === 'image/png';
      var isVideo = fileType === 'video/mp4';
      if (!isImage && !isVideo) {
        this.$message.error('请上传jpg/png图片或mp4视频!');
        return false;
      }
      if (isImage && fileSizeMB > 5) {
        this.$message.error('图片大小不能超过5MB!');
        return false;
      }
      if (isVideo && fileSizeMB > 200) {
        this.$message.error('视频大小不能超过200MB!');
        return false;
      }
      return this.doAdminDirectUploadFile(file.raw);
    },
    doAdminDirectUploadFile: function doAdminDirectUploadFile(file) {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var params, res, uploadUrl, contentType, uploadRes;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                params = {
                  file_name: file.name,
                  ext: file.name.split('.').pop().toLowerCase(),
                  content_type: file.type || 'application/octet-stream'
                };
                _context.next = 4;
                return Object(__WEBPACK_IMPORTED_MODULE_2__views_users_users_api_js__["adminDirectUploadFilesApi"])(params);

              case 4:
                res = _context.sent;

                if (!(res.data.ret === 0)) {
                  _context.next = 17;
                  break;
                }

                uploadUrl = res.data.detail.signedUrl;
                contentType = res.data.detail.content_type;
                _context.next = 10;
                return fetch(uploadUrl, {
                  method: 'PUT',
                  headers: new Headers({ 'Content-Type': contentType }),
                  body: file
                });

              case 10:
                uploadRes = _context.sent;

                if (uploadRes.ok) {
                  _context.next = 13;
                  break;
                }

                throw new Error('\u4E0A\u4F20\u5931\u8D25\uFF0C\u539F\u56E0: ' + uploadRes.status);

              case 13:
                _this.$message({ message: '上传成功', type: 'success' });
                return _context.abrupt('return', res.data.detail.url);

              case 17:
                _this.$message.error('上传失败，原因: ' + res.data.msg);
                return _context.abrupt('return', false);

              case 19:
                _context.next = 25;
                break;

              case 21:
                _context.prev = 21;
                _context.t0 = _context['catch'](0);

                _this.$message.error('上传失败，原因: ' + _context.t0.message);
                return _context.abrupt('return', false);

              case 25:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this, [[0, 21]]);
      }))();
    },

    // 附件上传,标准化字段结构
    formatStandardFile: function formatStandardFile(file, loginUser) {
      return {
        submit_admin_id: loginUser.id,
        submit_admin_name: loginUser.name,
        submit_at: __WEBPACK_IMPORTED_MODULE_3_moment___default()().format('YYYY-MM-DD HH:mm:ss'),
        name: file.name,
        size: file.size,
        url: file.url,
        uid: file.uid
      };
    }
  }
});

/***/ }),

/***/ 1523:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'VideoPlayerDialog',
  props: {
    // 是否显示弹窗（支持 .sync）
    visible: {
      type: Boolean,
      default: false
    },
    // 视频 URL 列表
    videos: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    // 打开时默认播放的视频索引
    index: {
      type: Number,
      default: 0
    }
  },
  data: function data() {
    return {
      currentIndex: 0,
      currentUrl: '',
      scale: 1,
      rotation: 0,
      translateX: 0,
      translateY: 0,
      isDragging: false,
      instantReset: false,
      dragStartX: 0,
      dragStartY: 0,
      startTranslateX: 0,
      startTranslateY: 0,
      isPlaying: false,
      videoCurrentTime: 0,
      videoDuration: 0
    };
  },

  computed: {
    dialogVisible: {
      get: function get() {
        return this.visible;
      },
      set: function set(val) {
        this.$emit('update:visible', val);
      }
    }
  },
  watch: {
    visible: function visible(val) {
      var _this = this;

      if (val) {
        this.currentIndex = Math.min(Math.max(this.index, 0), Math.max(this.videos.length - 1, 0));
        this.currentUrl = this.videos[this.currentIndex] || '';
        this.resetVideoState();
        this.$nextTick(function () {
          var wrapper = _this.$refs.videoDialogWrapper;
          wrapper && wrapper.focus();
        });
      }
    }
  },
  methods: {
    /**
     * 关闭弹窗时的清理
     */
    handleClose: function handleClose() {
      this.currentUrl = '';
      this.resetVideoState();
    },

    /**
     * ESC 关闭弹窗
     */
    closeDialog: function closeDialog() {
      this.dialogVisible = false;
    },

    /**
     * 重置视频播放状态
     */
    resetVideoState: function resetVideoState() {
      this.scale = 1;
      this.rotation = 0;
      this.translateX = 0;
      this.translateY = 0;
      this.isDragging = false;
      this.isPlaying = false;
      this.videoCurrentTime = 0;
      this.videoDuration = 0;
    },

    /**
     * @param {string} url 视频地址
     */
    goToVideo: function goToVideo(url) {
      var _this2 = this;

      this.instantReset = true;
      this.currentUrl = url;
      this.resetVideoState();
      this.$nextTick(function () {
        _this2.instantReset = false;
      });
    },

    /**
     * 切换到上一个视频
     */
    prevVideo: function prevVideo() {
      if (this.currentIndex > 0) {
        this.currentIndex--;
        this.goToVideo(this.videos[this.currentIndex] || '');
      }
    },

    /**
     * 切换到下一个视频
     */
    nextVideo: function nextVideo() {
      if (this.currentIndex < this.videos.length - 1) {
        this.currentIndex++;
        this.goToVideo(this.videos[this.currentIndex] || '');
      }
    },

    /**
     * 点击缩略图直接播放指定视频
     * @param {number} i 视频索引
     */
    playVideoByIndex: function playVideoByIndex(i) {
      if (i === this.currentIndex) return;
      if (i < 0 || i >= this.videos.length) return;
      this.currentIndex = i;
      this.goToVideo(this.videos[i] || '');
    },

    /**
     * 视频滚轮缩放
     * @param {WheelEvent} e
     */
    onVideoWheel: function onVideoWheel(e) {
      var delta = e.deltaY > 0 ? -0.1 : 0.1;
      var newScale = this.scale + delta;
      newScale = Math.max(0.5, Math.min(5, newScale));
      this.scale = parseFloat(newScale.toFixed(2));
    },
    rotateVideo: function rotateVideo() {
      this.rotation += 90;
    },

    /**
     * 开始拖拽视频
     * @param {MouseEvent} e
     */
    onDragStart: function onDragStart(e) {
      if (e.button !== 0) return;
      this.isDragging = true;
      this.dragStartX = e.clientX;
      this.dragStartY = e.clientY;
      this.startTranslateX = this.translateX;
      this.startTranslateY = this.translateY;
    },

    /**
     * 拖拽中
     * @param {MouseEvent} e
     */
    onDragMove: function onDragMove(e) {
      if (!this.isDragging) return;
      this.translateX = this.startTranslateX + (e.clientX - this.dragStartX) / this.scale;
      this.translateY = this.startTranslateY + (e.clientY - this.dragStartY) / this.scale;
    },

    /**
     * 结束拖拽
     */
    onDragEnd: function onDragEnd() {
      this.isDragging = false;
    },

    /**
     * 切换播放/暂停
     */
    togglePlay: function togglePlay() {
      var video = this.$refs.videoPlayer;
      if (!video) return;
      if (video.paused) {
        video.play();
        this.isPlaying = true;
      } else {
        video.pause();
        this.isPlaying = false;
      }
    },

    /**
     * 视频播放进度更新
     */
    onTimeUpdate: function onTimeUpdate() {
      var video = this.$refs.videoPlayer;
      if (video) {
        this.videoCurrentTime = video.currentTime;
      }
    },

    /**
     * 视频元数据加载完成
     */
    onLoadedMeta: function onLoadedMeta() {
      var video = this.$refs.videoPlayer;
      if (video) {
        this.videoDuration = video.duration || 0;
      }
    },

    /**
     * 视频播放结束
     */
    onVideoEnded: function onVideoEnded() {
      this.isPlaying = false;
    },

    /**
     * 点击进度条跳转
     * @param {MouseEvent} e
     */
    seekVideo: function seekVideo(e) {
      var video = this.$refs.videoPlayer;
      var track = e.currentTarget;
      if (!video || !track || !this.videoDuration) return;
      var rect = track.getBoundingClientRect();
      var ratio = Math.max(0, Math.min(1, (e.clientX - rect.left) / rect.width));
      video.currentTime = ratio * this.videoDuration;
      this.videoCurrentTime = video.currentTime;
    },

    /**
     * 格式化视频时间
     * @param {number} seconds
     * @returns {string}
     */
    formatVideoTime: function formatVideoTime(seconds) {
      if (!isFinite(seconds) || seconds < 0) return '00:00';
      var m = Math.floor(seconds / 60);
      var s = Math.floor(seconds % 60);
      return String(m).padStart(2, '0') + ':' + String(s).padStart(2, '0');
    }
  }
});

/***/ }),

/***/ 1575:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VideoPlayerDialog_vue__ = __webpack_require__(1523);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6a2c49d2_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VideoPlayerDialog_vue__ = __webpack_require__(1599);
function injectStyle (ssrContext) {
  __webpack_require__(1597)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VideoPlayerDialog_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6a2c49d2_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VideoPlayerDialog_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1597:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1598);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("073a162c", content, true, {});

/***/ }),

/***/ 1598:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, ".video-player-dialog.el-dialog{background-color:rgba(0,0,0,.5);-webkit-box-shadow:none!important;box-shadow:none!important;margin:0!important;width:100%!important;height:100vh;border-radius:0}.video-player-dialog .el-dialog__body{padding:0;height:100%;background-color:transparent!important}.video-player-dialog .el-dialog__header{padding:0}.video-player-dialog .el-dialog__headerbtn{position:fixed;top:-40px;right:-40px;width:80px;height:80px;margin:0;background-color:rgba(0,0,0,.5);border-radius:50%;overflow:hidden;-webkit-transition:background-color .15s;transition:background-color .15s;z-index:2050}.video-player-dialog .el-dialog__headerbtn:focus,.video-player-dialog .el-dialog__headerbtn:hover{background-color:rgba(0,0,0,.8)}.video-player-dialog .el-dialog__headerbtn .el-dialog__close{position:absolute;bottom:15px;left:15px;color:#fff;font-size:22px}.video-player-dialog .video-dialog-wrapper{-ms-flex-align:center;-ms-flex-pack:center;height:100%;position:relative;padding:0 60px;outline:none;overflow:hidden}.video-player-dialog .video-dialog-content,.video-player-dialog .video-dialog-wrapper{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;align-items:center;-webkit-box-pack:center;justify-content:center}.video-player-dialog .video-dialog-content{-webkit-box-flex:1;-ms-flex:1;flex:1;-ms-flex-align:center;-ms-flex-pack:center;cursor:-webkit-grab;cursor:grab;padding-bottom:130px;-webkit-box-sizing:border-box;box-sizing:border-box;background-color:transparent!important}.video-player-dialog .video-dialog-content.is-dragging{cursor:-webkit-grabbing;cursor:grabbing}.video-player-dialog .video-transform-wrapper{display:inline-block;position:relative;-webkit-transition:-webkit-transform .1s ease-out;transition:-webkit-transform .1s ease-out;transition:transform .1s ease-out;transition:transform .1s ease-out,-webkit-transform .1s ease-out;-webkit-transform-origin:center center;transform-origin:center center;background-color:transparent!important}.video-player-dialog .video-transform-wrapper.no-transition{-webkit-transition:none;transition:none}.video-player-dialog .video-player{margin-top:10px;max-width:100%;max-height:calc(100vh - 130px);width:auto;height:auto;outline:none;background-color:transparent;display:block;cursor:pointer}.video-player-dialog .video-nav-arrow{position:absolute;top:50%;-webkit-transform:translateY(-50%);transform:translateY(-50%);width:44px;height:44px;border-radius:50%;background-color:hsla(0,0%,100%,.6);display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;cursor:pointer;-webkit-transition:background-color .3s,opacity .3s;transition:background-color .3s,opacity .3s;z-index:10}.video-player-dialog .video-nav-arrow i{font-size:22px;color:#fff;-webkit-text-stroke:2px #fff}.video-player-dialog .video-nav-arrow:hover{background-color:hsla(0,0%,100%,.4)}.video-player-dialog .video-nav-arrow.disabled{opacity:.3;cursor:not-allowed}.video-player-dialog .video-nav-arrow.disabled:hover{background-color:hsla(0,0%,100%,.2)}.video-player-dialog .video-nav-prev{left:12px}.video-player-dialog .video-nav-next{right:12px}.video-player-dialog .custom-video-controls{position:absolute;bottom:75px;left:50%;-webkit-transform:translateX(-50%);transform:translateX(-50%);height:40px;width:50%;background:rgba(0,0,0,.5);display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;gap:12px;padding:0 16px;z-index:20;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.video-player-dialog .custom-video-controls .control-btn{font-size:36px;color:#fff;cursor:pointer;-ms-flex-negative:0;flex-shrink:0;-webkit-transition:opacity .2s;transition:opacity .2s;display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;width:32px;height:32px;margin-left:-10px}.video-player-dialog .custom-video-controls .progress-track{-webkit-box-flex:1;-ms-flex:1;flex:1;height:6px;background:hsla(0,0%,100%,.25);border-radius:3px;cursor:pointer;position:relative;overflow:hidden}.video-player-dialog .custom-video-controls .progress-track:hover{height:8px;border-radius:4px}.video-player-dialog .custom-video-controls .progress-fill{height:100%;background:#409eff;border-radius:inherit;pointer-events:none}.video-player-dialog .custom-video-controls .time-text{font-size:12px;color:#fff;white-space:nowrap;-ms-flex-negative:0;flex-shrink:0;font-variant-numeric:tabular-nums}.video-player-dialog .custom-video-controls .scale-text{font-size:12px;color:#c0c4cc;white-space:nowrap;-ms-flex-negative:0;flex-shrink:0;font-variant-numeric:tabular-nums;min-width:32px;text-align:right}.video-player-dialog .video-thumbnails{position:absolute;bottom:0;left:0;right:0;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;gap:8px;padding:8px 16px;background:rgba(0,0,0,.5);overflow-x:auto;z-index:20;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.video-player-dialog .video-thumbnails::-webkit-scrollbar{height:6px}.video-player-dialog .video-thumbnails::-webkit-scrollbar-thumb{background:hsla(0,0%,100%,.3);border-radius:3px}.video-player-dialog .video-thumbnails .video-thumb-item{-webkit-box-flex:0;-ms-flex:0 0 auto;flex:0 0 auto;width:36px;height:54px;border-radius:4px;overflow:hidden;cursor:pointer;border:2px solid transparent;opacity:.7;-webkit-transition:border-color .2s,opacity .2s,-webkit-transform .2s;transition:border-color .2s,opacity .2s,-webkit-transform .2s;transition:border-color .2s,opacity .2s,transform .2s;transition:border-color .2s,opacity .2s,transform .2s,-webkit-transform .2s}.video-player-dialog .video-thumbnails .video-thumb-item:hover{opacity:1;-webkit-transform:translateY(-2px);transform:translateY(-2px)}.video-player-dialog .video-thumbnails .video-thumb-item.active{border-color:#409eff;opacity:1}.video-player-dialog .video-thumbnails .video-thumb-item .video-thumb-player{width:100%;height:100%;-o-object-fit:cover;object-fit:cover;display:block;background-color:#000}", "", {"version":3,"sources":["/workspace/src/views/user-workinfo/components/VideoPlayerDialog.vue"],"names":[],"mappings":"AACA,+BAA+B,gCAAiC,kCAAmC,0BAA2B,mBAAoB,qBAAsB,aAAa,eAAe,CACnM,AACD,sCAAsC,UAAU,YAAY,sCAAuC,CAClG,AACD,wCAAwC,SAAS,CAChD,AACD,2CAA2C,eAAe,UAAU,YAAY,WAAW,YAAY,SAAS,gCAAiC,kBAAkB,gBAAgB,yCAA0C,iCAAkC,YAAY,CAC1Q,AACD,kGAAkG,+BAAgC,CACjI,AACD,6DAA6D,kBAAkB,YAAY,UAAU,WAAW,cAAc,CAC7H,AACD,2CAAyH,sBAAsB,AAA2C,qBAAqB,AAAuB,YAAY,kBAAkB,eAAe,aAAa,eAAe,CAC9S,AACD,sFAF2C,oBAAoB,oBAAoB,aAAa,yBAAyB,AAAsB,mBAAmB,wBAAwB,AAAqB,sBAAuB,CAGrO,AADD,2CAA2C,mBAAmB,WAAW,OAAO,AAA8E,sBAAsB,AAA2C,qBAAqB,AAAuB,oBAAoB,YAAY,qBAAqB,8BAA8B,sBAAsB,sCAAuC,CAC1Z,AACD,uDAAuD,wBAAwB,eAAe,CAC7F,AACD,8CAA8C,qBAAqB,kBAAkB,kDAAmD,0CAA2C,kCAAmC,iEAAoE,uCAAuC,+BAA+B,sCAAuC,CACtY,AACD,4DAA4D,wBAAwB,eAAe,CAClG,AACD,mCAAmC,gBAAgB,eAAe,+BAA+B,WAAW,YAAY,aAAa,6BAA6B,cAAc,cAAc,CAC7L,AACD,sCAAsC,kBAAkB,QAAQ,mCAAmC,2BAA2B,WAAW,YAAY,kBAAkB,oCAAuC,oBAAoB,oBAAoB,aAAa,yBAAyB,sBAAsB,mBAAmB,wBAAwB,qBAAqB,uBAAuB,eAAe,oDAAuD,4CAA+C,UAAU,CACvgB,AACD,wCAAwC,eAAe,WAAW,4BAA4B,CAC7F,AACD,4CAA4C,mCAAsC,CACjF,AACD,+CAA+C,WAAY,kBAAkB,CAC5E,AACD,qDAAqD,mCAAsC,CAC1F,AACD,qCAAqC,SAAS,CAC7C,AACD,qCAAqC,UAAU,CAC9C,AACD,4CAA4C,kBAAkB,YAAY,SAAS,mCAAmC,2BAA2B,YAAY,UAAU,0BAA2B,oBAAoB,oBAAoB,aAAa,yBAAyB,sBAAsB,mBAAmB,SAAS,eAAe,WAAW,yBAAyB,sBAAsB,qBAAqB,gBAAgB,CAC/a,AACD,yDAAyD,eAAe,WAAW,eAAe,oBAAoB,cAAc,+BAAgC,uBAAwB,2BAA2B,2BAA2B,oBAAoB,yBAAyB,sBAAsB,mBAAmB,wBAAwB,qBAAqB,uBAAuB,WAAW,YAAY,iBAAiB,CACnb,AACD,4DAA4D,mBAAmB,WAAW,OAAO,WAAW,+BAAkC,kBAAkB,eAAe,kBAAkB,eAAe,CAC/M,AACD,kEAAkE,WAAW,iBAAiB,CAC7F,AACD,2DAA2D,YAAY,mBAAmB,sBAAsB,mBAAmB,CAClI,AACD,uDAAuD,eAAe,WAAW,mBAAmB,oBAAoB,cAAc,iCAAiC,CACtK,AACD,wDAAwD,eAAe,cAAc,mBAAmB,oBAAoB,cAAc,kCAAkC,eAAe,gBAAgB,CAC1M,AACD,uCAAuC,kBAAkB,SAAS,OAAO,QAAQ,oBAAoB,oBAAoB,aAAa,wBAAwB,qBAAqB,uBAAuB,QAAQ,iBAAiB,0BAA2B,gBAAgB,WAAW,yBAAyB,sBAAsB,qBAAqB,gBAAgB,CAC5W,AACD,0DAA0D,UAAU,CACnE,AACD,gEAAgE,8BAAiC,iBAAiB,CACjH,AACD,yDAAyD,mBAAmB,kBAAkB,cAAc,WAAW,YAAY,kBAAkB,gBAAgB,eAAe,6BAA6B,WAAY,sEAA2E,8DAAmE,sDAA2D,2EAAkF,CACvf,AACD,+DAA+D,UAAU,mCAAmC,0BAA0B,CACrI,AACD,gEAAgE,qBAAqB,SAAS,CAC7F,AACD,6EAA6E,WAAW,YAAY,oBAAoB,iBAAiB,cAAc,qBAAqB,CAC3K","file":"VideoPlayerDialog.vue","sourcesContent":["\n.video-player-dialog.el-dialog{background-color:rgba(0,0,0,0.5);-webkit-box-shadow:none !important;box-shadow:none !important;margin:0 !important;width:100% !important;height:100vh;border-radius:0\n}\n.video-player-dialog .el-dialog__body{padding:0;height:100%;background-color:transparent !important\n}\n.video-player-dialog .el-dialog__header{padding:0\n}\n.video-player-dialog .el-dialog__headerbtn{position:fixed;top:-40px;right:-40px;width:80px;height:80px;margin:0;background-color:rgba(0,0,0,0.5);border-radius:50%;overflow:hidden;-webkit-transition:background-color 0.15s;transition:background-color 0.15s;z-index:2050\n}\n.video-player-dialog .el-dialog__headerbtn:focus,.video-player-dialog .el-dialog__headerbtn:hover{background-color:rgba(0,0,0,0.8)\n}\n.video-player-dialog .el-dialog__headerbtn .el-dialog__close{position:absolute;bottom:15px;left:15px;color:#fff;font-size:22px\n}\n.video-player-dialog .video-dialog-wrapper{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;height:100%;position:relative;padding:0 60px;outline:none;overflow:hidden\n}\n.video-player-dialog .video-dialog-content{-webkit-box-flex:1;-ms-flex:1;flex:1;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;cursor:-webkit-grab;cursor:grab;padding-bottom:130px;-webkit-box-sizing:border-box;box-sizing:border-box;background-color:transparent !important\n}\n.video-player-dialog .video-dialog-content.is-dragging{cursor:-webkit-grabbing;cursor:grabbing\n}\n.video-player-dialog .video-transform-wrapper{display:inline-block;position:relative;-webkit-transition:-webkit-transform 0.1s ease-out;transition:-webkit-transform 0.1s ease-out;transition:transform 0.1s ease-out;transition:transform 0.1s ease-out, -webkit-transform 0.1s ease-out;-webkit-transform-origin:center center;transform-origin:center center;background-color:transparent !important\n}\n.video-player-dialog .video-transform-wrapper.no-transition{-webkit-transition:none;transition:none\n}\n.video-player-dialog .video-player{margin-top:10px;max-width:100%;max-height:calc(100vh - 130px);width:auto;height:auto;outline:none;background-color:transparent;display:block;cursor:pointer\n}\n.video-player-dialog .video-nav-arrow{position:absolute;top:50%;-webkit-transform:translateY(-50%);transform:translateY(-50%);width:44px;height:44px;border-radius:50%;background-color:rgba(255,255,255,0.6);display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;cursor:pointer;-webkit-transition:background-color 0.3s, opacity 0.3s;transition:background-color 0.3s, opacity 0.3s;z-index:10\n}\n.video-player-dialog .video-nav-arrow i{font-size:22px;color:#fff;-webkit-text-stroke:2px #fff\n}\n.video-player-dialog .video-nav-arrow:hover{background-color:rgba(255,255,255,0.4)\n}\n.video-player-dialog .video-nav-arrow.disabled{opacity:0.3;cursor:not-allowed\n}\n.video-player-dialog .video-nav-arrow.disabled:hover{background-color:rgba(255,255,255,0.2)\n}\n.video-player-dialog .video-nav-prev{left:12px\n}\n.video-player-dialog .video-nav-next{right:12px\n}\n.video-player-dialog .custom-video-controls{position:absolute;bottom:75px;left:50%;-webkit-transform:translateX(-50%);transform:translateX(-50%);height:40px;width:50%;background:rgba(0,0,0,0.5);display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;gap:12px;padding:0 16px;z-index:20;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none\n}\n.video-player-dialog .custom-video-controls .control-btn{font-size:36px;color:#fff;cursor:pointer;-ms-flex-negative:0;flex-shrink:0;-webkit-transition:opacity 0.2s;transition:opacity 0.2s;display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;width:32px;height:32px;margin-left:-10px\n}\n.video-player-dialog .custom-video-controls .progress-track{-webkit-box-flex:1;-ms-flex:1;flex:1;height:6px;background:rgba(255,255,255,0.25);border-radius:3px;cursor:pointer;position:relative;overflow:hidden\n}\n.video-player-dialog .custom-video-controls .progress-track:hover{height:8px;border-radius:4px\n}\n.video-player-dialog .custom-video-controls .progress-fill{height:100%;background:#409eff;border-radius:inherit;pointer-events:none\n}\n.video-player-dialog .custom-video-controls .time-text{font-size:12px;color:#fff;white-space:nowrap;-ms-flex-negative:0;flex-shrink:0;font-variant-numeric:tabular-nums\n}\n.video-player-dialog .custom-video-controls .scale-text{font-size:12px;color:#c0c4cc;white-space:nowrap;-ms-flex-negative:0;flex-shrink:0;font-variant-numeric:tabular-nums;min-width:32px;text-align:right\n}\n.video-player-dialog .video-thumbnails{position:absolute;bottom:0;left:0;right:0;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;gap:8px;padding:8px 16px;background:rgba(0,0,0,0.5);overflow-x:auto;z-index:20;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none\n}\n.video-player-dialog .video-thumbnails::-webkit-scrollbar{height:6px\n}\n.video-player-dialog .video-thumbnails::-webkit-scrollbar-thumb{background:rgba(255,255,255,0.3);border-radius:3px\n}\n.video-player-dialog .video-thumbnails .video-thumb-item{-webkit-box-flex:0;-ms-flex:0 0 auto;flex:0 0 auto;width:36px;height:54px;border-radius:4px;overflow:hidden;cursor:pointer;border:2px solid transparent;opacity:0.7;-webkit-transition:border-color 0.2s, opacity 0.2s, -webkit-transform 0.2s;transition:border-color 0.2s, opacity 0.2s, -webkit-transform 0.2s;transition:border-color 0.2s, opacity 0.2s, transform 0.2s;transition:border-color 0.2s, opacity 0.2s, transform 0.2s, -webkit-transform 0.2s\n}\n.video-player-dialog .video-thumbnails .video-thumb-item:hover{opacity:1;-webkit-transform:translateY(-2px);transform:translateY(-2px)\n}\n.video-player-dialog .video-thumbnails .video-thumb-item.active{border-color:#409eff;opacity:1\n}\n.video-player-dialog .video-thumbnails .video-thumb-item .video-thumb-player{width:100%;height:100%;-o-object-fit:cover;object-fit:cover;display:block;background-color:#000\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 1599:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-dialog',{attrs:{"visible":_vm.dialogVisible,"width":"100%","top":"0px","modal":false,"append-to-body":"","custom-class":"video-player-dialog"},on:{"update:visible":function($event){_vm.dialogVisible=$event},"close":_vm.handleClose}},[_c('div',{ref:"videoDialogWrapper",staticClass:"video-dialog-wrapper",attrs:{"tabindex":"-1"},on:{"keydown":[function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"space",32,$event.key,[" ","Spacebar"])){ return null; }$event.preventDefault();return _vm.togglePlay($event)},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"r",undefined,$event.key,undefined)){ return null; }$event.preventDefault();return _vm.rotateVideo($event)},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"esc",27,$event.key,["Esc","Escape"])){ return null; }return _vm.closeDialog($event)}],"wheel":function($event){$event.preventDefault();return _vm.onVideoWheel($event)}}},[(_vm.videos.length > 1)?_c('div',{staticClass:"video-nav-arrow video-nav-prev",class:{ disabled: _vm.currentIndex === 0 },on:{"click":_vm.prevVideo}},[_c('i',{staticClass:"el-icon-arrow-left"})]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"video-dialog-content",class:{ 'is-dragging': _vm.isDragging },on:{"mousedown":_vm.onDragStart,"mousemove":_vm.onDragMove,"mouseup":_vm.onDragEnd,"mouseleave":_vm.onDragEnd}},[_c('div',{staticClass:"video-transform-wrapper",class:{ 'no-transition': _vm.isDragging || _vm.instantReset },style:({ transform: ("scale(" + _vm.scale + ") translate(" + _vm.translateX + "px, " + _vm.translateY + "px) rotate(" + _vm.rotation + "deg)") })},[(_vm.currentUrl)?_c('video',{ref:"videoPlayer",staticClass:"video-player",attrs:{"src":_vm.currentUrl,"autoplay":""},on:{"timeupdate":_vm.onTimeUpdate,"loadedmetadata":_vm.onLoadedMeta,"play":function($event){_vm.isPlaying = true},"pause":function($event){_vm.isPlaying = false},"ended":_vm.onVideoEnded}}):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"custom-video-controls"},[_c('div',{staticClass:"control-btn",attrs:{"title":"播放/暂停（按 空格 键切换）"},on:{"click":_vm.togglePlay}},[(!_vm.isPlaying)?_c('svg',{staticStyle:{"display":"block"},attrs:{"viewBox":"0 0 24 24","width":"32","height":"32","fill":"#fff","stroke":"#fff","stroke-width":"2","stroke-linejoin":"round"}},[_c('path',{attrs:{"d":"M6 5 L19 12 L6 19 Z"}})]):_c('svg',{staticStyle:{"display":"block"},attrs:{"viewBox":"0 0 24 24","width":"32","height":"32","fill":"none","stroke":"#fff","stroke-width":"3","stroke-linecap":"round"}},[_c('line',{attrs:{"x1":"7","y1":"5","x2":"7","y2":"19"}}),_vm._v(" "),_c('line',{attrs:{"x1":"17","y1":"5","x2":"17","y2":"19"}})])]),_vm._v(" "),_c('div',{staticClass:"progress-track",on:{"click":_vm.seekVideo}},[_c('div',{staticClass:"progress-fill",style:({ width: _vm.videoDuration ? (_vm.videoCurrentTime / _vm.videoDuration * 100) + '%' : '0%' })})]),_vm._v(" "),_c('span',{staticClass:"time-text"},[_vm._v(_vm._s(_vm.formatVideoTime(_vm.videoCurrentTime))+" / "+_vm._s(_vm.formatVideoTime(_vm.videoDuration)))]),_vm._v(" "),_c('div',{staticClass:"control-btn",staticStyle:{"margin-left":"0"},attrs:{"title":"向右旋转（快捷键 R）"},on:{"click":_vm.rotateVideo}},[_c('svg',{staticStyle:{"display":"block"},attrs:{"viewBox":"0 0 24 24","width":"32","height":"32","fill":"none","stroke":"#fff","stroke-width":"2","stroke-linecap":"round","stroke-linejoin":"round"}},[_c('rect',{attrs:{"x":"9","y":"11","width":"11","height":"11","rx":"1.2"}}),_vm._v(" "),_c('path',{attrs:{"d":"M5 14 C5 10, 8 6, 14 6"}}),_vm._v(" "),_c('path',{attrs:{"d":"M14 6 L11 4 M14 6 L11 8"}})])]),_vm._v(" "),_c('span',{staticClass:"scale-text",attrs:{"title":"通过滚轮控制缩放大小"}},[_vm._v(_vm._s((_vm.scale * 100).toFixed(0))+"%")])]),_vm._v(" "),(_vm.videos.length)?_c('div',{staticClass:"video-thumbnails"},_vm._l((_vm.videos),function(url,i){return _c('div',{key:i,staticClass:"video-thumb-item",class:{ active: i === _vm.currentIndex },on:{"click":function($event){return _vm.playVideoByIndex(i)}}},[_c('video',{staticClass:"video-thumb-player",attrs:{"src":url,"preload":"metadata","muted":"","playsinline":""},domProps:{"muted":true}})])}),0):_vm._e(),_vm._v(" "),(_vm.videos.length > 1)?_c('div',{staticClass:"video-nav-arrow video-nav-next",class:{ disabled: _vm.currentIndex === _vm.videos.length - 1 },on:{"click":_vm.nextVideo}},[_c('i',{staticClass:"el-icon-arrow-right"})]):_vm._e()])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 3089:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(232);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(233);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__core_mixins_table_v3__ = __webpack_require__(1348);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_viewerjs_dist_viewer_css__ = __webpack_require__(1355);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_viewerjs_dist_viewer_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_viewerjs_dist_viewer_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_viewerjs__ = __webpack_require__(1360);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_viewerjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_viewerjs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__views_user_workinfo_user_workinfo_mixin_js__ = __webpack_require__(1517);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__views_user_workinfo_components_VideoPlayerDialog_vue__ = __webpack_require__(1575);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_3__core_mixins_table_v3__["a" /* default */], __WEBPACK_IMPORTED_MODULE_6__views_user_workinfo_user_workinfo_mixin_js__["a" /* default */]],
  components: { VideoPlayerDialog: __WEBPACK_IMPORTED_MODULE_7__views_user_workinfo_components_VideoPlayerDialog_vue__["a" /* default */] },
  data: function data() {
    return {
      id: this.$route.query.userid || 0,
      fields: [{ prop: 'id', label: 'ID', width: 80 }, { prop: 'created_at', label: '更新时间', width: 160 }, { prop: 'updated_by', label: '更新人', width: 120 }, { prop: 'audited_by', label: '审核人', width: 150 }, { prop: 'business_type_json', label: '行业', width: 150 }, { prop: 'work_type_cn', label: '工种', width: 120 }, { prop: 'content.belongto', label: '厂家', width: 150 }],
      videoPreviewVisible: false,
      videoPreviewVideos: [],
      videoPreviewIndex: 0
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, Vuex.mapState({
    userOptions: function userOptions(state) {
      return state.users.userOptions;
    }
  })),
  watch: {},
  created: function created() {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _this.$store.dispatch('getUserRelatedOptions');

            case 2:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },
  mounted: function mounted() {},

  methods: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, Vuex.mapActions([]), {
    getTableData: function getTableData(params) {
      params.userid = this.id;
      return request.page('getUserWorkInfoLog', params);
    },
    onViewPhotos: function onViewPhotos(index, i) {
      if (this.viewer) {
        this.viewer.destroy();
      }
      this.viewer = new __WEBPACK_IMPORTED_MODULE_5_viewerjs___default.a(document.getElementById('photoContainer' + i));
      this.viewer.view(index);
    },
    getBusinessType: function getBusinessType(row) {
      var businessTypeId = _.get(row, 'content.business_type');
      var businessTypeObj = this.userOptions.business_type.find(function (it) {
        return it.id + '' === businessTypeId + '';
      });
      return _.get(businessTypeObj, 'title', '-');
    },
    onPreviewVideo: function onPreviewVideo(url, row) {
      var _this2 = this;

      // 构造当前行所有视频 URL 列表，并计算点击视频的索引，交给 VideoPlayerDialog 播放
      var videoList = (row.content.workcard_photo || []).filter(function (photo) {
        return _this2.isVideoFile(photo);
      });
      this.videoPreviewVideos = videoList;
      this.videoPreviewIndex = Math.max(videoList.indexOf(url), 0);
      this.videoPreviewVisible = true;
    }
  })
});

/***/ }),

/***/ 5793:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(5794);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("13c8177c", content, true, {});

/***/ }),

/***/ 5794:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"UsersDetailWorkInfoLog.vue","sourceRoot":""}]);

// exports


/***/ }),

/***/ 5795:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('el-table',{staticStyle:{"width":"100%"},attrs:{"data":_vm.table,"stripe":"","highlight-current-row":"","border":""}},[_vm._l((_vm.fields),function(attr,index){return [(attr.prop === 'business_type_json')?_c('el-table-column',_vm._b({scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('span',[_vm._v(_vm._s(_vm.getBusinessType(scope.row)))])]}}],null,true)},'el-table-column',attr,false)):_c('el-table-column',_vm._b({},'el-table-column',attr,false))]}),_vm._v(" "),_c('el-table-column',{key:"workcard_photo",attrs:{"prop":"workcard_photo","label":"工作证"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('div',{staticStyle:{"width":"100%","overflow-x":"auto","display":"flex","flex-direction":"row","align-items":"center"},attrs:{"id":("photoContainer" + (scope.$index))}},[_vm._l((scope.row.content.workcard_photo),function(photo,index){return [(_vm.isVideoFile(photo))?_c('video',{key:'video-' + index,staticStyle:{"width":"80px","height":"80px","margin":"10px","object-fit":"cover","flex-shrink":"0","position":"relative","cursor":"pointer","background-color":"#a9a5a5ff"},attrs:{"src":photo,"preload":"metadata"},on:{"click":function($event){return _vm.onPreviewVideo(photo, scope.row)}}}):_c('img',{key:'img-' + index,staticClass:"avatar",staticStyle:{"width":"80px","height":"80px","padding":"10px","cursor":"zoom-in","flex-shrink":"0"},attrs:{"src":_vm._f("ossFormatJpg")(photo),"alt":""},on:{"click":function($event){return _vm.onViewPhotos(index,scope.$index)}}})]})],2)]}}])})],2),_vm._v(" "),_c('div',{staticClass:"pagination"},[_c('el-pagination',{attrs:{"background":"","current-page":_vm.pagination.current_page,"page-sizes":[20, 50, 100, 200],"page-size":_vm.pagination.per_page,"layout":"total, sizes, prev, pager, next, jumper","total":_vm.pagination.total},on:{"size-change":_vm.handleSizePageChange,"current-change":_vm.handleCurrentPageChange}})],1),_vm._v(" "),_c('video-player-dialog',{attrs:{"visible":_vm.videoPreviewVisible,"videos":_vm.videoPreviewVideos,"index":_vm.videoPreviewIndex},on:{"update:visible":function($event){_vm.videoPreviewVisible=$event}}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

});


// WEBPACK FOOTER //
// static/js/workinfo-log.7ba6284661be93b49026.js